import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RellenoService } from 'src/app/services/relleno.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-relleno-historial',
  templateUrl: './relleno-historial.component.html',
  styleUrls: ['./relleno-historial.component.scss']
})
export class RellenoHistorialComponent {

    id_campana:number = 0;
    tipo:string = "";
    historial: {fecha: Date, descripcion: string, cantidad: number, usuario: string, nom_mat: string, nombre_bg: string}[] = [];
  
    constructor(
        @Inject(MAT_DIALOG_DATA) public data : any,
        private rellenoS: RellenoService,
      ) { }
  
      ngOnInit(): void {
        this.id_campana = this.data.dataCampaign.id;
        this.getHistorialInventario();
      }
  
      getHistorialInventario(){
        this.rellenoS.getRellenoHistorial(this.id_campana).subscribe(
          (result: any) => {
            if (result.message == "Success") {
              this.historial = result.data;
            }
          },
          (err: any) => {
            Swal.fire({
              icon: 'error',
              title: 'Error al obtener información',
              text: 'Ocurrió un error al guardar el registro, por favor vuelva a intentarlo.'
            });
          }
        );
      }

}
